<template>
<a href="/" >
  <div class="header-wrapper">
    <img src="../../assets/Logotjee.png" class="img-responsive center-block" href="/">
  </div>
</a>
<header class="navbar navbar-default navbar-static-top">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div id="navbar" class="navbar-collapse collapse">
          <ul class="nav navbar-nav">
            <li href="/index"><a href="/index" >Welkom</a></li>
            <li class="dropdown" v-link-active>
              <a style="color:#F589A7; font-size: x-large;" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
              Kraampjes<span class="caret"></span></a>
              <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu">
                <li v-link-active>
                  <a v-link="{name: 'categorie', params: {id: 50, cname: 'alles-in-1-kraampje'}}">Alles-in-1 Kraampje</a>
                </li>
                <li v-link-active 
                v-for="item in MenuItems" :class="{ 'dropdown-submenu': item.Children.length > 0 }">
                <a :class="{ 'menu-blue': item.MenuItemId === 46 }" v-link="{ name: 'categorie', params: { id: item.MenuItemId, cname: $options.filters.slugurl(item.MenuText) }}" @click="selectCat(item)">{{item.MenuText}}</a>
                  <ul class="dropdown-menu">
                    <li v-link-active v-for="subitem in item.Children | orderBy 'MenuText'">
                      <a v-link="{ name: 'categorie', params: { cname: $options.filters.slugurl(subitem.MenuText), id: subitem.MenuItemId }}" @click="selectCat(subitem)">{{subitem.MenuText}}</a>
                    </li>
                  </ul>
                </li>
                <li v-link-active>
                <a v-link="{name: 'categorie', params: {id: 20, cname: 'jammer'}}">JAMMER!!</a>
                </li>
              </ul>
            </li>
            <li v-link="{ path: '/gastenboek'}"><a v-link="{ path: '/gastenboek'}">Gastenboek</a></li>
            <li class="dropdown"  v-link-active>
              <a  class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
              Klantenservice<span class="caret"></span></a>
              <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu">
                <li v-link-active v-link="{ name: 'algemeneVoorwaarden'}">
                <a v-link="{ name: 'algemeneVoorwaarden'}">Algemene voorwaarden</a>
                </li>
                <li v-link-active v-link="{ name: 'giftService'}">
                <a v-link="{ name: 'giftService'}">Kado Service</a>
                </li>
                <li v-link-active v-link="{ name: 'shipping'}">
                <a v-link="{ name: 'shipping'}">Verzenden en ophalen</a>
                </li>
                <li v-link-active v-link="{ name: 'paying'}">
                <a v-link="{ name: 'paying'}">Betaling</a>
                </li>
              </ul>
            </li>
            <li v-link="{ path: '/over-ons'}"><a v-link="{ path: '/over-ons'}">Over Ons</a></li>
          </ul>
          <div class="navbar-form navbar-right" role="search">
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Zoeken" v-model="searchTerm" @keyup.enter="search()">
            </div>
            <button type="submit" class="btn btn-default" @click="search()"> <span class="glyphicon glyphicon-search"></span>
            Zoeken</button>
          </div>
          <ul class="nav navbar-nav navbar-right">
            <li v-if="store.auth">
              <a href="#" @click="logout()">Uitloggen</a>
            </li>
            <li v-if="store.auth" class="dropdown"  v-link-active>
              <a  class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
              Overzicht<span class="caret"></span></a>
              <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu">
                <li v-link="{ path: '/dashboard/'}">
                  <a v-link="{ path: '/dashboard/'}">Artikelen</a>
                </li>
                <li v-link="{ name: 'addRubrics'}">
                  <a v-link="{ name: 'addRubrics'}">Rubrieken</a>
                </li>
                <li v-link="{ name: 'banner'}">
                  <a v-link="{ name: 'banner'}">(vakantie)banner</a>
                </li>
                <li v-link="{ name: 'admin-gastenboek'}">
                  <a v-link="{ name: 'admin-gastenboek'}">Gastenboek goedkeuren</a>
                </li>
                <li v-link="{ name: 'admin-order-overzicht'}">
                  <a v-link="{ name: 'admin-order-overzicht'}">Overzicht orders</a>
                </li>
                <li v-link="{ name: 'admin-gebruikers-overzicht'}">
                  <a v-link="{ name: 'admin-gebruikers-overzicht'}">Gebruikersteller</a>
                </li>
              </ul>
            </li>
            <li v-if="store.auth" v-link="{ path: '/addProduct'}">
              <a v-link="{ path: '/addProduct'}">Nieuwe advertentie</a>
            </li>
            <li v-link="{ name: 'order'}">
              <a style="color:#F589A7;font-size:200%;" v-link="{ name: 'order'}">
              <span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span>
              ({{store.cart.length}})</a>
            </li>
          </ul>
        </div><!--/.nav-collapse -->
</header>
<slot></slot>
</template>

<script>
import store from '../../store'
export default {
  created () {
    this.getMenuItems()
  },
  components: {
  },
  data: function () {
    return {
      store: store,
      MenuItems: null,
      searchTerm: ''
    }
  },
  methods: {
    getMenuItems: function () {
      $.ajax({
        type: 'GET',
        url: store.root + 'api/MenuItems',
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        success: function (response) {
          this.MenuItems = response
        }.bind(this)
      })
    },
    logout: function () {
      store.logout()
      this.$route.router.go({name: 'Welkom'})
    },
    search: function (e) {
      this.$route.router.go({ path: '/search/' + this.searchTerm })
    },
    selectCat: function (name) {
      store.selectedCat = name
    }
  }
}
</script>

<style>
.current-menu-parent {
background-color:#f22853; }
.current-menu-parent > a {
    color: #ffffff !important;
}
.menu-blue {
  color:#337ab7 !important;
}
</style>



// WEBPACK FOOTER //
// NavigationHeader.vue?0ca05d54